import React, { useContext, useState } from 'react';

import useFAQService from '../../../app/services/hooks/useFAQService';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import FAQForm from './forms/FAQForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface FAQFormData {
    question: string;
    answer: string;
    order: number;
}

const defaultFAQFormData: FAQFormData = {
    question: '',
    answer: '',
    order: 0
};

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const FAQCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [faq, setFaq] = useState<FAQFormData>(defaultFAQFormData);
    const [errorFields, setErrorFields] = useState<any>();

    const { fetchingStoreFAQ, storeFAQ } = useFAQService();

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando pregunta frecuente...');
        storeFAQ(faq, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <FAQForm
                        faqForm={faq}
                        setFaqForm={setFaq}
                        errorFields={errorFields}
                        isCreate={true}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreFAQ} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreFAQ} />
                </div>
            </div>
        </>
    );
};

export default FAQCreate;

